import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web'
import { ZoneContextManager } from '@opentelemetry/context-zone'
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http'
import { registerInstrumentations } from '@opentelemetry/instrumentation'
import { Resource } from '@opentelemetry/resources'
import { SimpleSpanProcessor, TracerConfig, WebTracerProvider } from '@opentelemetry/sdk-trace-web'
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions'

try {
  const monitoringProviderConfig: TracerConfig = {
    resource: new Resource({
      [ATTR_SERVICE_NAME]: 'datable-ui',
    }),
  }

  const monitoringProvider = new WebTracerProvider(monitoringProviderConfig)

  const otlpExporter = new OTLPTraceExporter({
    url: import.meta.env.DEV ? 'http://127.0.0.1:4318/v1/traces' : 'https://monitor.dtbl.io:4318/v1/traces',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  monitoringProvider.addSpanProcessor(new SimpleSpanProcessor(otlpExporter))
  monitoringProvider.register({
    contextManager: new ZoneContextManager(),
  })

  registerInstrumentations({
    instrumentations: [
      // getWebAutoInstrumentations initializes all the package.
      // it's possible to configure each instrumentation if needed.
      getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-user-interaction': {
          // config can be added here for example
          // we can initialize the instrumentation only for prod
          // enabled: import.meta.env.PROD,
          enabled: false,
        },
        '@opentelemetry/instrumentation-fetch': {
          enabled: false,
        },
        '@opentelemetry/instrumentation-document-load': {
          enabled: false,
        },
        '@opentelemetry/instrumentation-xml-http-request': {
          enabled: true,
        },
      }),
    ],
  })
  console.log('tracing initialized')
} catch (e) {
  console.error('error initializing tracing', e)
}
